var React = require( 'react' );
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var TagInput = require('./tagInput.jsx');
var SelectedTagList = require('./selectedTagList.jsx');
var TargetForSelectList = require('./targetForSelectList.jsx');

var MessageForm = createReactClass({
    mixins: [PureRenderMixin],

    handleOnSubmit: function(event){
        event.preventDefault();

        var formData = {
            subjectText: this.refs.subjectText.value.trim(),
            subjectImage: this.refs.subjectImage.value.trim(),
            title: this.refs.title.value.trim(),
            tagIDs: this.props.message.messageData.tags || [],
            text: this.refs.text.value.trim(),
            actionImage: this.refs.actionImage.value.trim(),
            actionTarget: this.refs.actionTarget.value.trim(),

            targetIDs: (this.props.message.messageData.meta && this.props.message.messageData.meta.target) || [],
            sendPush: this.props.message.messageData.meta && !!this.props.message.messageData.meta.sendPush,
            pushText: this.refs.pushText.value.trim(),
            pushLink: this.refs.pushLink.value.trim()
        };

        this.props.onSubmit(formData);
    },

    handleSubjectTextChange: function(event){
        this.props.changeSubjectText(event.target.value);
    },

    handleSubjectImageChange: function(event){
        this.props.changeSubjectImage(event.target.value);
    },

    handleTitleChange: function(event){
        this.props.changeTitle(event.target.value);
    },

    handleTagAdd: function(tag){
        this.props.addTag(tag);
    },

    handleTagRemove: function(tag){
        this.props.removeTag(tag);
    },

    handleTextChange: function(event){
        this.props.changeText(event.target.value);
    },

    handleActionImageChange: function(event){
        this.props.changeActionImage(event.target.value);
    },

    handleActionTargetChange: function(event){
        this.props.changeActionTarget(event.target.value);
    },

    handleTargetChange: function(target){
        this.props.changeTarget(target);
    },

    handleSendPushChange: function(event){
        var currentSendPush = !!parseInt(event.target.value, 10);
        var previousSendPush = !!(this.props.message.messageData.meta && this.props.message.messageData.meta.sendPush);

        if(currentSendPush !== previousSendPush){
            this.props.changeSendPush(currentSendPush);
        }
    },

    handlePushTextChange: function(event){
        this.props.changePushText(event.target.value);
    },

    handlePushLinkChange: function(event){
        this.props.changePushLink(event.target.value);
    },

    render: function () {
        var envelope = this.props.message.messageData || {};
        var meta = this.props.message.messageData.meta || {};

        if(this.props.isEdit || this.props.isCopy){
            meta.sendPush = !!meta.sendNotification;
            meta.pushText = meta.notification && meta.notification.text;
            meta.pushLink = meta.notification && meta.notification.deepLink;
        }

        // envelope.tags(tagIDs) -> selectTags
        var selectedTags = envelope.tags.map(function(tagID){
            var tag = {
                _id: tagID
            };

            var len = this.props.tags.length;
            for(var i = 0; i < len; i++){
                if(this.props.tags[i]._id === tagID){
                    tag.name = this.props.tags[i].name;
                    break;
                }
            }

            return tag;
        }.bind(this));

        return (
            <form className="message-form" noValidate onSubmit={this.handleOnSubmit} autoComplete="off">
                <div className="row">
                    <div className="input-field small-12 column">
                        <label htmlFor="subjectTextInput"><span className="heading">Subject</span>
                            <input id="subjectTextInput" type="text" value={(envelope.subject && envelope.subject.text) || ''} required onChange={this.handleSubjectTextChange} ref="subjectText" />
                        </label>
                    </div>
                    <div className="input-field small-12 column">
                        <label htmlFor="subjectImageInput"><span className="heading">Subject Image</span>
                            <input id="subjectImageInput" type="url" value={(envelope.subject && envelope.subject.image) || ''} onChange={this.handleSubjectImageChange} ref="subjectImage" />
                        </label>
                    </div>
                    <div className="input-field small-12 column">
                        <label htmlFor="titleInput"><span className="heading">Title</span>
                            <input id="titleInput" type="text" value={envelope.title || ''} required onChange={this.handleTitleChange} ref="title" />
                        </label>
                    </div>
                    <fieldset className="input-field small-12 column">
                        <legend className="heading">Tags</legend>
                        <TagInput
                            tagsForSelect={this.props.tags}
                            onTagAdd={this.handleTagAdd} />
                        <SelectedTagList
                            selectedTags={selectedTags}
                            onTagRemove={this.handleTagRemove}
                             />
                    </fieldset>
                    <div className="input-field small-12 column">
                        <label htmlFor="messageInput"><span className="heading">Message</span>
                            <textarea id="messageInput" value={envelope.text || ''} required onChange={this.handleTextChange} ref="text" />
                        </label>
                    </div>
                    <div className="input-field small-12 column">
                        <label htmlFor="actionImageInput"><span className="heading">Action Image</span>
                            <input id="actionImageInput" type="url" value={(envelope.action && envelope.action.image) || ''} onChange={this.handleActionImageChange} ref="actionImage" />
                        </label>
                    </div>
                    <div className="input-field small-12 column">
                        <label htmlFor="actionTargetInput"><span className="heading">Action Url</span>
                            <input id="actionTargetInput" type="url" value={(envelope.action && envelope.action.target) || ''} onChange={this.handleActionTargetChange} ref="actionTarget" />
                        </label>
                    </div>
                    <fieldset className="input-field small-12 column">
                        <legend className="heading">Target</legend>
                        <TargetForSelectList
                            targetsForSelect={this.props.targets}
                            selectedTargetIDs={meta.target || []}
                            onTargetChange={this.handleTargetChange}
                             />
                    </fieldset>
                    <fieldset className="input-field small-12 column">
                        <legend className="heading">Send Push?</legend>
                        <input type="radio" name="sendPush" id="sendPushYes" value="1" checked={!!meta.sendPush === true} onChange={this.handleSendPushChange} disabled={this.props.isEdit} /><label htmlFor="sendPushYes">Yes</label>
                        <input type="radio" name="sendPush" id="sendPushNo" value="0" checked={!!meta.sendPush === false} onChange={this.handleSendPushChange} disabled={this.props.isEdit} /><label htmlFor="sendPushNo">No</label>
                    </fieldset>
                    <div id="sendPushPane" className={!meta.sendPush ? 'hide' : ''}>
                        <div className="input-field small-12 column">
                            <label htmlFor="pushTextInput"><span className="heading">Push Text</span>
                                <input id="pushTextInput" type="text" value={meta.pushText || ''} onChange={this.handlePushTextChange} ref="pushText" disabled={this.props.isEdit} />
                            </label>
                        </div>
                        <div className="input-field small-12 column">
                            <label htmlFor="pushLinkInput"><span className="heading">Push Link</span>
                                <input id="pushLinkInput" type="url" value={meta.pushLink || ''} onChange={this.handlePushLinkChange} ref="pushLink" disabled={this.props.isEdit} />
                            </label>
                        </div>
                    </div>

                    <div className="small-12 column">
                        <div className="action-field">
                            <button className="blue button" type="submit">Submit</button>
                        </div>
                    </div>
                </div>
            </form>
        );
    }
});

module.exports = MessageForm;



// WEBPACK FOOTER //
// ./src/common/routes/message-center/components/layout/messageForm.jsx